import React, { Component } from "react";
import OfferTag from "../../assets/discount.png";
import { connect } from "react-redux";
import { colors } from "../../css/colors";
import { imageURL } from "../../utils/constants";
import { Toast, toastMsgConfig } from "../../components/toast";

class ProductItem extends Component {
  addToCart = (item) => {
    const { cart, allProducts, site_data } = this.props;
    const enableInstalment = site_data && site_data.enable_instalment_payment;

    if (enableInstalment) {
      const cartProducts = (allProducts || []).filter((p) => cart && cart.includes(p.id));
      const cartHasInstalment = cartProducts.some((p) => p.is_instalment_product === "Y");
      const isInstalment = item.is_instalment_product === "Y";

      if (isInstalment && cart && cart.length > 0) {
        Toast("Installment products can only be purchased individually. Please remove other products from cart first.", toastMsgConfig("e"));
        return;
      }
      if (cartHasInstalment) {
        Toast("Your cart contains an installment product. Please complete that purchase first or remove it to add other products.", toastMsgConfig("e"));
        return;
      }
    }

    this.props.dispatch({
      type: "ADD_TO_CART",
      payload: {
        id: [item.id, ...this.props.cart],
      },
    });
  };

  removeFromCart = (item) => {
    this.props.dispatch({
      type: "REMOVE_FROM_CART",
      payload: {
        id: item.id,
      },
    });
  };

  render() {
    const { item, index, cart, user_id } = this.props;
    return (
      <>
        <div className="prodDiv">
          {item.tag && <h6 className="tag">{item.tag}</h6>}
          <img
            src={
              item.photo_url && item.photo_url !== ""
                ? item.photo_url
                : imageURL
            }
            alt="Product thumbnail"
          />

          <div className="productContent">
            <h4>{item.title}</h4>

            <h6>
              {item.is_paid == "N"
                ? "Free"
                : ( item.c_code?item.c_code
                : "")
                     +
                  " " +
                  item.price}
              {item.discount_percentage > 0 && (
                <span className="discount">
                  {  item.c_code?item.c_code
                    : ""}{" "}
                  {item.price_before_discount}
                </span>
              )}
              {item.discount_percentage > 0 && (
                <span
                  style={{ color: "green", fontWeight: 700, paddingLeft: 6 }}
                >
                  {" "}
                  {item.discount_percentage} % Off{" "}
                </span>
              )}
            </h6>

            {item.is_instalment_product === "Y" && this.props.site_data?.enable_instalment_payment && (
              <p
                style={{
                  fontSize: 11,
                  color: "#1976d2",
                  fontWeight: 600,
                  margin: "4px 0",
                  background: "#e3f2fd",
                  padding: "3px 8px",
                  borderRadius: 4,
                  display: "inline-block",
                }}
              >
                <i className="fa fa-credit-card" style={{ marginRight: 4 }}></i>
                Installment option available - View details inside
              </p>
            )}

            <div style={{ display: "flex", flexDirection: "row" }}>
              {item.offer_available && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginRight: 10,
                  }}
                >
                  <img
                    src={OfferTag}
                    style={{ height: 14, width: 14, marginRight: 4 }}
                  />
                  <h5 style={{ color: colors.CRUSTA, fontSize: 12 }}>
                    Offers Available
                  </h5>
                </div>
              )}

              {item.purchase_count_status !== 0 &&
                item.total_prod_purchaseed > 0 && (
                  <h5 style={{ color: colors.PICTON_BLUE, fontSize: 12 }}>
                    {item.total_prod_purchaseed} Student(s) Purchased
                  </h5>
                )}
            </div>
            {/* <p dangerouslySetInnerHTML={{ __html: item.about.length > 80 ? (item.about.slice(0, 80) + '...') : item.about }} ></p> */}

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                position: "sticky",
                bottom: 0,
              }}
            >
              {cart && cart.includes(item.id) && !item.is_enrolled && (
                <button
                  style={{
                    marginRight: 4,
                    color: colors.CARDINAL,
                    borderColor: colors.CARDINAL,
                  }}
                  onClick={() => this.removeFromCart(item)}
                >
                  Remove from Cart <i className="fa fa-remove"></i>
                </button>
              )}

              {(!cart || (cart && !cart.includes(item.id))) &&
                item.remaining_products > 0 &&
                !item.is_enrolled && (
                  <button
                    style={{ marginRight: 4 }}
                    onClick={() => this.addToCart(item)}
                  >
                    Add to Cart <i className="fa fa-shopping-cart"></i>
                  </button>
                )}

              {item.remaining_products == 0 && !item.is_enrolled && (
                <button
                  disabled={true}
                  style={{
                    marginRight: 4,
                    color: colors.CRUSTA,
                    borderColor: colors.CRUSTA,
                    fontWeight: 700,
                    borderWidth: 0,
                    paddingLeft: 0,
                  }}
                >
                  Sold Out
                </button>
              )}

              {item.is_enrolled && (
                <button
                  disabled={true}
                  style={{
                    marginRight: 4,
                    color: colors.JADE,
                    borderColor: colors.JADE,
                    fontWeight: 700,
                    borderWidth: 0,
                    paddingLeft: 0,
                  }}
                >
                  <i className="fa fa-check" style={{ padding: 0 }}></i>{" "}
                  Purchased
                </button>
              )}

              <button
                style={{ marginLeft: 8 }}
                onClick={this.props.onClickView}
              >
                View <i className="fa fa-angle-right"></i>
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state.cart, ...state.auth, ...state.home };
};

export default connect(mapStateToProps)(ProductItem);
